import {
    Button,
    //Flex,
    FormControl,
    FormLabel,
    Select,
    Input,
    Stack,
    useColorModeValue,
    Avatar,
    AvatarBadge,
    IconButton,
    Center,
  } from '@chakra-ui/react'
import { FaUserEdit } from 'react-icons/fa'
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../../slices/adminAuthSlice";
import { useUpdateAdminMutation } from "../../slices/adminApiSlice";
import { useNavigate } from 'react-router-dom';
import { ToastService } from '../../services/toast/toastService';

const AdminProfile = () => {
 
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState(null);
  const [shopCode, setShopCode] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const { success, error } = ToastService();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { adminInfo } = useSelector( (state) => state.adminAuth );
  const [profileImage, setProfileImage] = useState(adminInfo.image_url);
  const fileInputRef = useRef(null);
  const [ updateProfile, { isLoading } ] = useUpdateAdminMutation()
  const bgColorDark = useColorModeValue('gray.50', 'gray.700');

  useEffect(() => {
    setName(adminInfo.name);
    setEmail(adminInfo.email);
    setPhone(adminInfo.phone);
    setShopCode(adminInfo.shop_code);

  },[ adminInfo.name, adminInfo.email, adminInfo.phone, adminInfo.shop_code])

  const submitHandler = async (e) => {
    e.preventDefault();
   
    try{
      const formData = new FormData();
      formData.append("name", name);
      formData.append("phone", phone);
      formData.append("shop_code", shopCode);
      formData.append("profileImage", selectedFile);
       // Include email only if it's different from the current one
       if (email !== adminInfo.email) {
        formData.append("email", email);
      }

      const responseFromApiCall = await updateProfile(formData).unwrap();
      dispatch( setCredentials( { ...responseFromApiCall.user } ) );
      success("Profile updated successfully.")
    }catch(err){
      //console.log(err)
      error(err.data?.message || 'An unexpected error occurred.')
    }
    
  };

  const cancelHandler = async (e) => {
    navigate('/admin');
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
        const imageUrl = URL.createObjectURL(file);
        setProfileImage(imageUrl); // Update state with the new image URL
        setSelectedFile(file);
    }
  };

  const handleBadgeClick = () => {
    if (fileInputRef.current) {
        fileInputRef.current.click(); // Programmatically trigger the file input
    }
  };

  return (
    
      <Stack
          spacing={4}
          w={'full'}
          maxW={'lg'}
          bg={bgColorDark}
          rounded={'xl'}
          boxShadow={'2xl'}
          p={6}
          my={6}>
        {/* <Heading lineHeight={1.1} fontSize={{ base: '2xl', sm: '3xl' }}>
          Admin Profile
        </Heading> */}
        <FormControl id="userName">
          <Stack >
            <Center>
              <label htmlFor="file-upload">
              {selectedFile ? (
              <Avatar
                id="selectedAvatar"
                size="xl"
                src={profileImage} // Use the file URL if a new file is selected
                cursor="pointer"
                />
                ) : (
                adminInfo.image_url && (
                  <Avatar
                    id="avatar"
                    size="xl"
                    src={
                      adminInfo.image_url
                        ? adminInfo.image_url
                        : '/default.png'
                    }
                    cursor="pointer"
                  >
                    <AvatarBadge
                      as={IconButton}
                      size="sm"
                      rounded="full"
                      top="-10px"
                      aria-label="Edit Image"
                      onClick={handleBadgeClick}
                      icon={<FaUserEdit />}
                    />
                </Avatar>
                )
              )}
                <input
                  id="file-upload"
                  name='profileImage'
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  style={{ display: 'none' }} // Hide the input element
                />
              </label>
            </Center>
          </Stack>
        </FormControl>
        <FormControl id="userName" isRequired>
          <FormLabel>User name</FormLabel>
          <Input
            placeholder="UserName"
            _placeholder={{ color: 'gray.500' }}
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)} 
          />
        </FormControl>
        <FormControl id="email" isRequired>
          <FormLabel>Email address</FormLabel>
          <Input
            placeholder="your-email@example.com"
            _placeholder={{ color: 'gray.500' }}
            type="email"
            value={email}
            disabled
            //onChange={(e) => setEmail(e.target.value)} 
          />
        </FormControl>
        <FormControl id="phone" isRequired>
          <FormLabel>Phone number</FormLabel>
          <Input
            _placeholder={{ color: 'gray.500' }}
            type="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)} 
          />
        </FormControl>
        <FormControl id="shopCode" isRequired>
          <FormLabel>Shop code</FormLabel>
          <Select
            value={shopCode}
            onChange={(e) => setShopCode(e.target.value)}
          >
            <option value="K">K</option>
            <option value="L">L</option>
            <option value="Y">Y</option>
          </Select>
        </FormControl>
        <Stack spacing={6} direction={['column', 'row']}>
          <Button
            colorScheme='teal'
            variant={'outline'}
            width="full" 
            mt={4}
            _hover={{ bg: 'teal.500', color: 'white' }} 
            onClick={submitHandler}
            isLoading={isLoading}>
            Save
          </Button>
          <Button
            colorScheme='red'
            variant={'outline'}
            width="full" 
            mt={4}
            _hover={{ bg: 'red.500', color: 'white' }} 
            onClick={cancelHandler}>
            Cancel
          </Button>
        </Stack>
      </Stack>
  )
}

export default AdminProfile;